import {
  Box,
  Button,
  IconButton,
  Image,
  Select,
  Td,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { FaPlay } from "react-icons/fa";
import DeleteModal from "../components/common/Modal/DeleteModal";
import CreateModal from "../components/common/Modal/Modal";
import PreviewModal from "../components/common/Modal/PreviewModal";
import CreateTable2 from "../components/common/Table/PaginationTable";
import CreateTable from "../components/common/Table/Table";
import CreateInput from "../components/common/TextInputs/Input";
import Fallback from "../components/common/ui/Fallback";
import Loading from "../components/common/ui/Loading";
import AddToWallet from "../components/users/AddToWallet";
import BankDetailsModal from "../components/users/BankDetails";
import Modal from "../components/users/Modal";
import UpdateWallet from "../components/users/UpdateWallet";
import useActions from "../hooks/useActions";
import { useNavigator } from "../hooks/useNavigator";
import {
  deleteUser,
  downloadUsers,
  getAllAds,
  getAllSubscribtions,
  addVote,
  checkVoteStatus,
  getAllUsers,
  getContestVideos,
  getUserNotifications,
  removeVote,
  getUserSubscriptions,
  getWalletHistory,
  updatePanDetails,
  updateUser,
  updateUserSubscription,
} from "../utils/api";

const Users = () => {
  const [users, setUsers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [totalUsers, setTotalUsers] = React.useState(0);
  const [updateUserWallet, setUpdateUserWallet] = React.useState({});
  const [walletHistory, setWalletHistory] = React.useState([]);

  const getWalletHistoryHandler = async (id) => {
    setLoading(true);
    const [success, data] = await getWalletHistory(id);

    if (success) {
      setWalletHistory(data.history);
    }
    setLoading(false);
  };
  const [notification, setNotification] = React.useState(false);

  const {
    isOpen: isOpenModal1,
    onOpen: onOpenModal1,
    onClose: onCloseModal1,
  } = useDisclosure();

  const getNotification = async (id) => {
    setLoading(true);
    const [success, data] = await getUserNotifications(id);
    if (success) {
      setNotification(data);
      onOpenModal1();
    }

    setLoading(false);
  };
  const [BankDetails, setBankDetails] = React.useState(false);
  const {
    isOpen: isOpenModal2,
    onOpen: onOpenModal2,
    onClose: onCloseModal2,
  } = useDisclosure();

  const {
    isOpen: isOpenModal3,
    onOpen: onOpenModal3,
    onClose: onCloseModal3,
  } = useDisclosure();

  const {
    isOpen: isOpenModal4,
    onOpen: onOpenModal4,
    onClose: onCloseModal4,
  } = useDisclosure();

  const {
    isOpen: isOpenModal5,
    onOpen: onOpenModal5,
    onClose: onCloseModal5,
  } = useDisclosure();

  const {
    isOpen: isOpenModal6,
    onOpen: onOpenModal6,
    onClose: onCloseModal6,
  } = useDisclosure();

  const {
    isOpen: isOpenModal7,
    onOpen: onOpenModal7,
    onClose: onCloseModal7,
  } = useDisclosure();

  const {
    isOpen: isOpenModal8,
    onOpen: onOpenModal8,
    onClose: onCloseModal8,
  } = useDisclosure();

  const {
    isOpen: isOpenModal9,
    onOpen: onOpenModal9,
    onClose: onCloseModal9,
  } = useDisclosure();

  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();

  const [pan, setPan] = React.useState({});
  const [events, setEvents] = React.useState([]);
  const [selectedUserId, setSelectedUserId] = React.useState(null);
  const [contestVideos, setContestVideos] = React.useState([]);
  const [selectedEventName, setSelectedEventName] = React.useState("");
  const [previewUrl, setPreviewUrl] = React.useState("");
  const [previewTitle, setPreviewTitle] = React.useState("Preview");
  const [subscription, setSubscription] = React.useState([]);
  const [allSubscriptions, setAllSubscriptions] = React.useState([]);
  const [userId, setUserId] = React.useState({});

  const getAllUsersHandler = async () => {
    if (user?.getUser) {
      const [success, data] = await getAllUsers();
      if (success) {
        setUsers(data);
      }
    }
    setLoading(false);
  };

  const usersToCSV = (users) => {
    const headers = [
      "Name",
      "Email",
      "Phone Number",
      "Status",
      "Total Coin",
      "Referral Coin",
      "Promotional Coin",
      "Content Sharing Coin",
      "App Sharing Coin",
      "Reward Video Coin",
      "Withdrawable Coin",
      "Locked Coin",
    ];
    const fields = [
      "name",
      "email",
      "phoneNumber",
      "isEnable",
      "totalCoin",
      "referralCoin",
      "promotionalCoin",
      "contentSharingCoin",
      "appSharingCoin",
      "rewardVideoCoin",
      "freeCoin",
      "lockedCoin",
    ];
    const csvRows = [headers.join(",")];
    users.forEach((user) => {
      const row = fields.map((field) => {
        let value = user[field];
        // Convert isEnable to readable status
        if (field === "isEnable") {
          value = value ? "Active" : "Blocked";
        } else if (typeof value === "boolean") {
          value = value ? "true" : "false";
        }
        if (value === undefined || value === null) value = "";
        // Escape quotes and commas
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
        ) {
          value = '"' + value.replace(/"/g, '""') + '"';
        }
        return value;
      });
      csvRows.push(row.join(","));
    });
    return csvRows.join("\n");
  };

  const downloadUsersHandler = async () => {
    setLoading(true);
    try {
      const [success, data] = await downloadUsers();
      console.log(data);
      if (success && data && Array.isArray(data.users)) {
        const csv = usersToCSV(data.users);
        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "users-data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        toast({
          title: "Success",
          description: "Users data downloaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "Failed to download users data",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to download users data",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  const [navigate, user] = useNavigator(getAllUsersHandler);
  const [updateAction, deleteAction] = useActions();
  const toast = useToast();
  const updatePanCardHandler = async () => {
    setLoading(true);
    if (pan.file === undefined || pan.file === null) {
      return alert("Please select a file");
    }
    const formData = new FormData();
    formData.append("image", pan.file);
    const [success, data] = await updatePanDetails(pan.id, formData);
    if (success) {
      toast({
        title: "Success",
        description: "Pan Card Updated",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      onCloseModal7();
    }
    setLoading(false);
  };

  const getUserSubscriptionsHandler = async (id) => {
    setLoading(true);
    const [success, data] = await getUserSubscriptions(id);
    if (success) {
      setSubscription(data);
      onOpenModal3();
    }
    setLoading(false);
  };

  const getAllSubsHandler = async () => {
    const [success, data] = await getAllSubscribtions();
    if (success) {
      setAllSubscriptions(data);
    }
  };

  const parseVoteStatus = (data, userId, likes) => {
    if (typeof data === "boolean") return data;
    if (data?.liked !== undefined) return data.liked;
    if (data?.isLiked !== undefined) return data.isLiked;
    if (Array.isArray(likes)) return likes.includes(userId);
    return false;
  };

  const normalizeContestVideos = (videos) =>
    (Array.isArray(videos) ? videos : videos?.videos || []).map((entry) => ({
      ...entry,
      likesCount:
        (Array.isArray(entry.likes) ? entry.likes.length : entry.likes ?? 0) +
        (Number(entry.bonusVotes) || 0),
      genreNames: entry.genres?.map((g) => g.name).join(", ") || "N/A",
    }));

  const fetchVoteStatuses = async (videos, userId) => {
    const withVoteStatus = await Promise.all(
      videos.map(async (video) => {
        const [success, data] = await checkVoteStatus(video._id, userId);
        return {
          ...video,
          hasVoted: success
            ? parseVoteStatus(data, userId, video.likes)
            : Array.isArray(video.likes) && video.likes.includes(userId),
        };
      })
    );
    return withVoteStatus;
  };

  const getUserEventsHandler = async (userId) => {
    setLoading(true);
    setSelectedUserId(userId);
    const [success, data] = await getAllAds();
    if (success) {
      setEvents(data);
      onOpenModal8();
    } else {
      toast({
        title: "Error",
        description: "Failed to fetch events",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  const getContestVideosHandler = async (eventId, eventName) => {
    if (!selectedUserId) return;
    setLoading(true);
    const [success, data] = await getContestVideos(eventId, selectedUserId);
    if (success) {
      const videos = normalizeContestVideos(data);
      const videosWithVoteStatus = await fetchVoteStatuses(
        videos,
        selectedUserId
      );
      setContestVideos(videosWithVoteStatus);
      setSelectedEventName(eventName);
      onOpenModal9();
    } else {
      toast({
        title: "Error",
        description: "Failed to fetch contest videos",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  const handleVote = async (videoId, hasVoted) => {
    if (!selectedUserId) return;
    setLoading(true);
    const [success] = hasVoted
      ? await removeVote(videoId, selectedUserId)
      : await addVote(videoId, selectedUserId);
    if (success) {
      setContestVideos((prev) =>
        prev.map((video) =>
          video._id === videoId
            ? {
                ...video,
                hasVoted: !hasVoted,
                likesCount: hasVoted
                  ? Math.max(0, video.likesCount - 1)
                  : video.likesCount + 1,
              }
            : video
        )
      );
      toast({
        title: "Success",
        description: hasVoted ? "Vote removed" : "Vote added",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Error",
        description: hasVoted ? "Failed to remove vote" : "Failed to add vote",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  const handlePlayVideo = (url, title) => {
    if (!url) {
      toast({
        title: "No video",
        description: "Video URL is not available",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setPreviewUrl(url);
    setPreviewTitle(title);
    onPreviewOpen();
  };

  const updateUserStatusHandler = async (userId, isEnable) => {
    setLoading(true);
    try {
      const [success, data] = await updateUser({ isEnable }, userId);
      if (success) {
        toast({
          title: "Success",
          description: `User ${
            isEnable ? "unblocked" : "blocked"
          } successfully`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        getAllUsersHandler();
      } else {
        toast({
          title: "Error",
          description: `Failed to ${isEnable ? "unblock" : "block"} user`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: `Failed to ${isEnable ? "unblock" : "block"} user`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",

        flexDirection: "column",
        padding: "1rem",
      }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <Loading />
        </div>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          gap: 2,
        }}
      >
        {user?.addUser && (
          <Modal title={" Create User"} reload={getAllUsersHandler} />
        )}

        {user?.getUser && (
          <>
            <Button
              onClick={downloadUsersHandler}
              colorScheme="blue"
              variant="solid"
              mr={2}
              style={{
                padding: "0.5rem 2rem",
              }}
            >
              Download Users CSV
            </Button>
          </>
        )}
      </Box>

      {user?.getUser ? (
        <CreateTable2
          pagging
          setUsers={setUsers}
          setTotalUsers={setTotalUsers}
          users={users}
          searchby={["name", "email", "phoneNumber"]}
          head={[
            "Subscription Actions",
            "Actions",
            "Profile",
            "Name",
            "Email",
            "Phone-Number",
            "Bank Account",
            "Status",
            "Total",
            "Referral",
            "Promotional",
            "Content Sharing",
            "App Sharing",
            "Reward Video",
            "Withdrawable",
            "Locked",
          ]}
          rows={(row) => {
            return (
              <>
                <Td>
                  <Box
                    sx={{ display: "flex", gap: 2, flexDirection: "column" }}
                  >
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme="blue"
                      variant="solid"
                      onClick={() => {
                        getUserSubscriptionsHandler(row._id);
                      }}
                    >
                      Subscriptions
                    </Button>
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme="blue"
                      variant="solid"
                      onClick={() => {
                        getAllSubsHandler();
                        setUserId((prev) => ({ ...prev, userId: row._id }));
                        onOpenModal4();
                      }}
                    >
                      Add Subscription
                    </Button>
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme="blue"
                      variant="solid"
                      onClick={() => {
                        setUpdateUserWallet((prev) => ({
                          ...prev,
                          userId: row._id,
                          totalCoin: row.totalCoin,
                          referralCoin: row.referralCoin,
                          promotionalCoin: row.promotionalCoin,
                          appSharingCoin: row.appSharingCoin,
                          contentSharingCoin: row.contentSharingCoin,
                          rewardVideoCoin: row.rewardVideoCoin,
                          freeCoin: row.freeCoin,
                          lockedCoin: row.lockedCoin,
                        }));
                        onOpenModal5();
                      }}
                    >
                      Update User Wallet
                    </Button>
                    <Button
                      colorScheme={"blue"}
                      sx={{
                        width: "100%",
                      }}
                      variant="solid"
                      onClick={() => {
                        getWalletHistoryHandler(row._id);
                        onOpenModal6();
                      }}
                    >
                      Wallet History
                    </Button>
                    <Button
                      colorScheme={"blue"}
                      sx={{
                        width: "100%",
                      }}
                      variant="solid"
                      onClick={() => {
                        getNotification(row._id);
                      }}
                    >
                      Notifications
                    </Button>
                  </Box>
                </Td>
                <Td>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                    }}
                  >
                    {user?.updateUser && (
                      <>
                        <Modal
                          title={"Update User"}
                          reload={getAllUsersHandler}
                          updateData={row}
                          update={{
                            name: row.name,
                            email: row.email,
                            phoneNumber: row.phoneNumber,
                            image: row.image,
                            aadharNumber: row.aadharNumber,
                            ifsc: row.ifsc,
                            accountNumber: row.accountNumber,
                            bankName: row.bankName,
                            branchName: row.branchName,
                            upi: row.upi,
                            panNumber: row.panNumber,
                          }}
                        />
                      </>
                    )}
                    {user?.deleteUser && (
                      <DeleteModal
                        onClick={async () => {
                          setLoading(true);
                          await deleteAction(row._id, deleteUser);
                          getAllUsersHandler();
                          setLoading(false);
                        }}
                      />
                    )}
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme={row.isEnable ? "red" : "green"}
                      variant="solid"
                      onClick={() => {
                        updateUserStatusHandler(row._id, !row.isEnable);
                      }}
                    >
                      {row.isEnable ? "Block User" : "Unblock User"}
                    </Button>
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme="blue"
                      variant="solid"
                      onClick={() => {
                        setPan({
                          id: row._id,
                        });
                        onOpenModal7();
                      }}
                    >
                      Update Pan Card
                    </Button>
                    <AddToWallet row={row} reload={getAllUsersHandler} />
                    <Button
                      sx={{
                        width: "100%",
                      }}
                      colorScheme="purple"
                      variant="solid"
                      onClick={() => {
                        getUserEventsHandler(row._id);
                      }}
                    >
                      Event
                    </Button>
                  </Box>
                </Td>
                <Td>
                  <Image
                    src={row.image}
                    rounded="full"
                    boxSize="50px"
                    loading="lazy"
                  />
                </Td>
                <Td>{row.name}</Td>
                <Td>{row.email}</Td>
                <Td>{row.phoneNumber}</Td>

                <Td>
                  <Button
                    colorScheme="blue"
                    variant="solid"
                    onClick={() => {
                      setBankDetails(row ? row : "No Bank Details");
                      onOpenModal2();
                    }}
                  >
                    View
                  </Button>
                </Td>
                <Td>
                  <Text
                    color={row.isEnable ? "green.500" : "red.500"}
                    fontWeight="bold"
                  >
                    {row.isEnable ? "Active" : "Blocked"}
                  </Text>
                </Td>
                <Td>{row.totalCoin}</Td>
                <Td>{row.referralCoin}</Td>
                <Td>{row.promotionalCoin}</Td>
                <Td>{row.contentSharingCoin}</Td>
                <Td>{row.appSharingCoin}</Td>
                <Td>{row.rewardVideoCoin}</Td>
                <Td>{row.freeCoin}</Td>
                <Td>{row.lockedCoin}</Td>
              </>
            );
          }}
        />
      ) : (
        <Fallback />
      )}

      <CreateModal
        title={"Subscriptions"}
        isOpen={isOpenModal3}
        onClose={onCloseModal3}
        table
      >
        <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
          <Text sx={{ fontWeight: "700" }} size="lg">
            History
          </Text>
          {subscription?.map((sub, index) => (
            <Text sx={{ fontWeight: "600" }}>
              {index} : {sub.message}
            </Text>
          ))}
        </Box>
      </CreateModal>
      <CreateModal
        title={"Add Subscription"}
        isOpen={isOpenModal4}
        onClose={onCloseModal4}
        create={async () => {
          setLoading(true);
          await updateAction(userId, "id", updateUserSubscription);
          setUserId({});
          onCloseModal4();
          getAllUsersHandler();
          setLoading(false);
        }}
      >
        <Select
          placeholder="select subscription"
          onChange={(e) => {
            setUserId((prev) => ({ ...prev, subscriptionId: e.target.value }));
          }}
        >
          {allSubscriptions?.map((sub) => (
            <option value={sub._id}>{sub.title}</option>
          ))}
        </Select>
      </CreateModal>

      <UpdateWallet
        isOpenModal5={isOpenModal5}
        onCloseModal5={onCloseModal5}
        data={updateUserWallet}
        reload={getAllUsersHandler}
      />
      <CreateModal
        isOpen={isOpenModal6}
        onClose={onCloseModal6}
        title={"Wallet History"}
        table
      >
        <CreateTable
          data={walletHistory}
          head={["title", "balance", "type", "date"]}
          rows={(row) => (
            <>
              <Td>{row?.title}</Td>
              <Td>{row?.balance}</Td>
              <Td>{row?.type}</Td>
              <Td>{row?.date}</Td>
            </>
          )}
        />
      </CreateModal>
      <CreateModal
        isOpen={isOpenModal1}
        onClose={onCloseModal1}
        title={"Notification"}
        table
      >
        <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
          <CreateTable
            data={notification}
            head={["title", "description", "date", "image", "read"]}
            rows={(row) => (
              <>
                <Td>{row?.title}</Td>
                <Td>{row?.description.slice(0, 22)}</Td>
                <Td>{row?.date}</Td>
                <Td>
                  <Image src={row?.image} rounded="full" boxSize="50px" />
                </Td>
                <Td>{row?.read ? "true" : "false"}</Td>
              </>
            )}
          />
        </Box>
      </CreateModal>
      <BankDetailsModal
        open={isOpenModal2}
        onClose={onCloseModal2}
        BankDetails={BankDetails}
      />

      <CreateModal
        isOpen={isOpenModal7}
        onClose={onCloseModal7}
        title={"Edit Pan Card"}
        create={updatePanCardHandler}
      >
        <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
          <CreateInput
            type="file"
            onChange={(e) => {
              setPan((prev) => ({
                ...prev,
                file: e.target.files[0],
              }));
            }}
          />
          <Image
            src={pan?.file ? URL.createObjectURL(pan?.file) : pan?.image}
            rounded="full"
            boxSize="50px"
          />
        </Box>
      </CreateModal>

      <CreateModal
        isOpen={isOpenModal8}
        onClose={onCloseModal8}
        title={"Events"}
        table
      >
        <CreateTable
          data={events}
          searchby={["name"]}
          head={["Image", "Name", "Position", "Expired Date", "Contest"]}
          rows={(row) => (
            <>
              <Td>
                {row.image ? (
                  <Image
                    src={row.image}
                    alt={row.name}
                    boxSize="50px"
                    rounded="md"
                    objectFit="cover"
                  />
                ) : (
                  "No Image"
                )}
              </Td>
              <Td>{row.name}</Td>
              <Td>{row.position}</Td>
              <Td>
                {row.expiredDate
                  ? new Date(row.expiredDate).toLocaleDateString()
                  : "N/A"}
              </Td>
              <Td>
                <Button
                  colorScheme="purple"
                  variant="solid"
                  size="sm"
                  onClick={() => {
                    getContestVideosHandler(row._id, row.name);
                  }}
                >
                  Contest
                </Button>
              </Td>
            </>
          )}
        />
      </CreateModal>

      <CreateModal
        isOpen={isOpenModal9}
        onClose={onCloseModal9}
        title={`Contest Videos${selectedEventName ? ` - ${selectedEventName}` : ""}`}
        table
      >
        {contestVideos?.length > 0 ? (
          <CreateTable
            data={contestVideos}
            searchby={["name", "language", "subcategory"]}
            head={[
              "Banner",
              "Name",
              "Description",
              "Language",
              "Duration",
              "Genres",
              "Views",
              "Likes",
              "Date",
              "Play",
              "Vote",
            ]}
            rows={(row) => (
              <>
                <Td>
                  {row.horizontalBanner ? (
                    <Image
                      src={row.horizontalBanner}
                      alt={row.name}
                      boxSize="60px"
                      rounded="md"
                      objectFit="cover"
                    />
                  ) : (
                    "No Image"
                  )}
                </Td>
                <Td>{row.name}</Td>
                <Td>{row.description?.slice(0, 40) || "N/A"}</Td>
                <Td>{row.language || "N/A"}</Td>
                <Td>{row.duration || "N/A"}</Td>
                <Td>{row.genreNames}</Td>
                <Td>{row.view ?? 0}</Td>
                <Td>{row.likesCount}</Td>
                <Td>
                  {row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString()
                    : "N/A"}
                </Td>
                <Td>
                  <IconButton
                    aria-label="Play video"
                    icon={<FaPlay />}
                    size="sm"
                    colorScheme="teal"
                    variant="solid"
                    isRound
                    onClick={() => handlePlayVideo(row.url, row.name || "Video")}
                    isDisabled={!row.url}
                  />
                </Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme={row.hasVoted ? "red" : "green"}
                    variant="solid"
                    onClick={() => handleVote(row._id, row.hasVoted)}
                  >
                    {row.hasVoted ? "Remove Vote" : "Add Vote"}
                  </Button>
                </Td>
              </>
            )}
          />
        ) : (
          <Text>No contest videos found</Text>
        )}
      </CreateModal>

      <PreviewModal
        isOpen={isPreviewOpen}
        onClose={onPreviewClose}
        url={previewUrl}
        title={previewTitle}
        urlType="video"
      />
    </Box>
  );
};

export default Users;
